
import { Word } from './types';

export const MOCK_WORDS: Word[] = [
  { id: '1', english: 'Abundant', pos: 'adj.', chinese: '大量的，充裕的', unit: 'Unit 1' },
  { id: '2', english: 'Benevolent', pos: 'adj.', chinese: '仁慈的，慈善的', unit: 'Unit 1' },
  { id: '3', english: 'Consequence', pos: 'n.', chinese: '后果，影响', unit: 'Unit 1' },
  { id: '4', english: 'Diligence', pos: 'n.', chinese: '勤奋，用功', unit: 'Unit 2' },
  { id: '5', english: 'Eloquent', pos: 'adj.', chinese: '雄辩的，有口才的', unit: 'Unit 2' },
  { id: '6', english: 'Frugal', pos: 'adj.', chinese: '节俭的', unit: 'Unit 2' },
  { id: '7', english: 'Gullible', pos: 'adj.', chinese: '易受骗的', unit: 'Unit 3' },
  { id: '8', english: 'Hypocrisy', pos: 'n.', chinese: '虚伪', unit: 'Unit 3' }
];

export const SYSTEM_INSTRUCTION = `
You are an English teacher assistant. 
Input: An English word and an audio of the student saying its Chinese meaning.
Task: Judge if the student's spoken Chinese meaning is correct for that English word.
Output: Return JSON format ONLY:
{
  "isCorrect": boolean,
  "transcription": "what you heard",
  "feedback": "short explanation"
}
`;
